import { inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivateFn,
	Router,
	RouterStateSnapshot
} from '@angular/router';
import { of } from 'rxjs';

import { LocalStorageService } from '../services';

export const canActivateMain: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const localStorageService = inject(LocalStorageService);
	const router = inject(Router);

	const token = localStorageService.getItem<string>('token-futura');

	if (!token) {
		router.navigate(['/auth/login']);
	}

	return of(!!token);
};
